import {useState,useEffect} from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
  RadioGroup,
  Radio,
} from "@heroui/react";

const Announcements = ({ isOpen, onClose }) => {
    // Auto-close after 3 seconds
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
      if (isOpen) {
        // console.log('Popup timer started');
            // 检查 localStorage 是否已标记公告为已读
        const hasSeen = localStorage.getItem('hasSeenAnnouncementV2.1');
        if (!hasSeen) {
          setIsVisible(true);
          
          // 标记为已读
          // localStorage.setItem('hasSeenAnnouncementV2.0', 'true');
        }
        const timer = setTimeout(() => {
          clearTimeout(timer);
  
          onClose();
        }, 20000);
  
      }
    }, [isOpen, onClose]);

  const [modalPlacement, setModalPlacement] = useState("center");
  if (!isOpen || !isVisible) return null
   else return (
    <div>

      <Modal isOpen={isOpen} placement={modalPlacement} >
        <ModalContent>
              <ModalHeader className="flex flex-col gap-1">通知</ModalHeader>
              <ModalBody>
                <p>
W3Swap流动性已上线内测版本！

                </p>

              </ModalBody>
              <ModalFooter>
                <Button color="primary" onPress={onClose} className=" text-center text-white">
                  知道了
                </Button>
              </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
}
export default Announcements;